import React, { useContext } from "react";
import { DEFAULT_HEADER } from "../../default";
import StyledText from "../../../primitives/StyledText";
import { BannerContext } from "../../context";
import { getProp } from "../content/helpers/getProp";

function Header() {
  const { config } = useContext(BannerContext);

  const { header } = config;

  if (!header) return <></>;

  return (
    <StyledText
      customStyles={{
        fontSize: "29px",
        fontWeight: 500,
        lineHeight: "32px",
      }}
    >
      {getProp(header, DEFAULT_HEADER)}
    </StyledText>
  );
}

export default Header;
